import { Component } from '@angular/core';
import { SscShellComponent } from '../ssc-shell/ssc-shell';

@Component({
  selector: 'app-model-benchmark-page',
  standalone: true,
  imports: [SscShellComponent],
  templateUrl: './model-benchmark.html',
})
export class ModelBenchmarkPage {}
